import classNames from "classnames";
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { ColorVariantType } from "../../../../types";
import { getAbsoluteImagePath } from "@utils/dom";
import { useConfig } from "@hooks";

export interface InputTextProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    ColorVariantType {
  shape?: "default" | "underline" | "pills";
  additionalClassname?: string;
  error?: boolean;
  editIcon?: boolean;
}

const InputText = forwardRef<HTMLInputElement, InputTextProps>(
  (
    {
      variant = "primary",
      shape = "pills",
      error,
      editIcon,
      additionalClassname,
      ...props
    },
    ref
  ) => {
    const { mode: clientMode } = useConfig();
    const mode = clientMode ? clientMode : "vacanceole";

    const INPUTTEXT_CLASS = {
      base: `tw-border-gray-300 tw-py-1 tw-px-3 tw-leading-8 tw-outline-none tw-transition-colors tw-duration-200 tw-ease-in-out`,
      shape: {
        default: `tw-rounded tw-border`,
        underline: `tw-border-b-1 tw-border-b`,
        pills: `tw-border tw-rounded-full`,
      },
      variant: {
        default: `focus:tw-border-gray-400`,
        primary: `${
          mode === "vacanceole"
            ? "focus:tw-border-v_blue-dark"
            : "focus:tw-border-primary_corseole-400"
        }`,
        secondary: `focus:tw-border-secondary-400`,
        success: `focus:tw-border-green-400`,
        info: `focus:tw-border-blue-400`,
        warning: `focus:tw-border-yellow-400`,
        danger: `focus:tw-border-v_red-dark`,
      },
      error: `tw-border-red-500`,
    };

    const defaultClass = classNames(
      INPUTTEXT_CLASS.base,
      error ? INPUTTEXT_CLASS.error : INPUTTEXT_CLASS.variant[variant],
      INPUTTEXT_CLASS.shape[shape],
      additionalClassname
    );

    let customClass = defaultClass;
    if (props.className) {
      customClass = props.className;
    }

    return editIcon ? (
      <div className="tw-relative">
        <input className={customClass} {...props} />
        <span className="tw-absolute tw-top-2 tw-right-2">
          <img
            className="tw-w-4"
            src={getAbsoluteImagePath("/assets/img/icons/crayon.png")}
          ></img>
        </span>
      </div>
    ) : (
      <input className={customClass} {...props} />
    );
  }
);

InputText.propTypes = {
  //
};

export default InputText;
